import {parseAsString, useQueryState} from "nuqs";
import {useEffect, useState} from "react";

export default function useDebouncedQueryState(queryKey: string, delay = 300){
    const [queryVal, setQueryVal] = useQueryState(queryKey, parseAsString.withDefault(''));
    const [value, setValue] = useState(queryVal)
    useEffect(() => {
        const handler = setTimeout(() => {
            if(queryVal !== value) setQueryVal(value)
        }, delay);

        // Cleanup function that cancels the timeout if the value changes before the delay expires
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return [value, setValue, queryVal] as [string, (val: string) => void, string]
}
